/**
 * The platform (including operating system and hardware) is running on.
 */
export enum Platform {
  /** Android platform. */
  Android,
  /** IPhone platform. */
  IPhone,
  /** IPad platform. */
  IPad,
  /** Mac platform. */
  Mac,
  /** Unknown platform. */
  Unknown
}
